import React from 'react'
import { Loading } from '../Loading'
import { useAppsContext } from '../../contexts'
import { Routes } from './routes/Routes'

const Router = () => {
  const { apps, loading, appPaths } = useAppsContext()

  if (loading) {
    return <Loading />
  }

  return <Routes apps={apps} appPaths={appPaths} />
}

export { Router }
